import React from "react";

export const InstagramIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.888"
      height="27.883"
      viewBox="0 0 27.888 27.883"
    >
      <path
        data-name="Icon awesome-instagram"
        d="M13.942,9.03a7.149,7.149,0,1,0,7.149,7.149A7.137,7.137,0,0,0,13.942,9.03Zm0,11.8a4.648,4.648,0,1,1,4.647-4.648,4.656,4.656,0,0,1-4.647,4.648ZM23.05,8.738A1.667,1.667,0,1,1,21.383,7.07,1.664,1.664,0,0,1,23.05,8.738Zm4.735,1.692a8.252,8.252,0,0,0-2.252-5.842,8.305,8.305,0,0,0-5.842-2.252c-2.3-.131-9.2-.131-11.5,0A8.294,8.294,0,0,0,2.345,4.582,8.279,8.279,0,0,0,.093,10.424c-.131,2.3-.131,9.2,0,11.5A8.252,8.252,0,0,0,2.345,27.77a8.316,8.316,0,0,0,5.842,2.252c2.3.131,9.2.131,11.5,0a8.251,8.251,0,0,0,5.842-2.252,8.306,8.306,0,0,0,2.252-5.842c.131-2.3.131-9.2,0-11.5ZM24.811,24.4a4.705,4.705,0,0,1-2.65,2.65c-1.835.728-6.19.56-8.219.56s-6.39.162-8.219-.56a4.705,4.705,0,0,1-2.65-2.65c-.728-1.835-.56-6.191-.56-8.219s-.162-6.39.56-8.219a4.705,4.705,0,0,1,2.65-2.65c1.835-.728,6.19-.56,8.219-.56s6.39-.162,8.219.56a4.705,4.705,0,0,1,2.65,2.65c.728,1.835.56,6.191.56,8.219S25.539,22.569,24.811,24.4Z"
        transform="translate(0.005 -2.238)"
      />
    </svg>
  );
};
